import { Tenant } from './tenant.model';

export class Portfolio {
  id: number;
  name: string;
  historyDate: string;
  portfolioId: number;
  fundValue: number;
  dailyChange: number;
  mtdChange: number;
  qtdChange: number;
  ytdChange: number;
  expTotal: number;
  committedCash: number;
  unfundedValue: number;
  fidelityCash: number;
  expCash: number;
  longValue: number;
  longDailyPercent: number;
  expLong: number;
  longAcquiredValue: number;
  expLongAcquired: number;
  shortValue: number;
  shortDailyPercent: number;
  expShort: number;
  editVersionsCount: number;
  displayForm?: boolean;
  tenant: Tenant;
  portfolioType?: string;
}
